<template>
  <div class="riseupGoal card-box container-padding">
    <div class="container-padding">
      <div class="goal">יעד riseup</div>
      <div class="title">
        <div>כמה כסף ישאר בסוף {{this.monthName}}?</div>
      </div>
      <div class="value">
        ***
      </div>
      <div class="disclaimer">
        <img class="notice-icon" :src="require('@/assets/icons/exclemation-mark-yellow.svg')">
        <span>אם תעמדו ביעד ההוצאות המשתנות</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'RiseupGoal',
  computed: {
    ...mapGetters('cashflowView', ['monthName']),
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  .riseupGoal {
    margin-bottom: 16px;

    .container-padding {
      padding: 18px;
    }

    .goal {
      color: $riseup_yellow;
      font-size: 10px;
      font-weight: bold;
    }

    .title {
      font-family: GretaSans;
      font-size: 24px;
      font-weight: bold;
      margin: 4px 0 22px;
    }

    .value {
      font-family: SimplerPro;
      font-size: 46px;
      line-height: 32px;
      margin: 0 0 18px;
      color: $riseup_yellow;
    }

    .disclaimer {
      font-size: 16px;

      .notice-icon {
        width: 12px;
        height: 12px;
        vertical-align: middle;
      }
    }
  }
</style>
